export const TABLE_HEAD = [
  { id: 'manager', label: 'Manager', alignRight: false },
  { id: 'employees', label: 'Employees', alignRight: false },
  { id: '' },
];

export const INITIAL_FORM_STATE = { team: [], managerId: '' };

export const ADD_TEAM_FORM_TITLE = 'Create a New Team';

export const EDIT_TEAM_FORM_TITLE = 'Edit a Team';
